export default __webpack_public_path__ + "static/media/ohoskin-2.99717192.mp4";